<template>
  <div>
    <div v-if="show" class="popup-overlay-en" @click="closePopup">
      <div class="popup-content-en" @click.stop :class="{ 'popup-disabled': loading }">
        <div class="popup-head-en">
          <div class="popup-image-mob-en"></div>
          <button class="close-button-en" @click="closePopup" :disabled="loading">&times;</button>
        </div>
        <div class="popup-body-en">
          <div class="popup-text-en">
            <!-- <p class="pop-desc-en">Feel the Power... Experience it Yourself!</p> -->
            <h4 class="popup-heading-four-en">Back to School is Different with Monglish!</h4>
            <h2 class="popup-heading-two-en">Get 2 Months Free<br class="max-sm:hidden">and <br class="hidden max-sm:flex" /> Save 1800 SAR</h2>
            <p class="pop-desc2-en">The strongest offer to kickstart your child’s English learning begins now with Monglish.</p>
            <p class="pop-desc2-mob-en">The strongest offer to kickstart <br /> your child’s English learning begins now with Monglish.</p>

            <form @submit.prevent="register" class="pop-form-en" :class="{ 'form-disabled': loading }">
              <div class="inline-group-en">
                <div class="form-pop-en">
                  <label for="fullName" class="pop-label-en">Full Name</label>
                  <input type="text" class="pop-input-en" id="fullName" placeholder="Full Name" v-model="fullName" 
                  required :disabled="loading" />
                </div>
                <div class="form-pop-en">
                  <label for="phoneNumber" class="pop-label-en">WhatsApp number</label>
                  <vue-tel-input 
                    class="pop-input-en" 
                    v-model:phoneNumber="phoneNumber" 
                    v-model:country="country" 
                    @input="onPhoneInput" 
                    @validate="onPhoneValidate" 
                    mode="international" 
                    :preferred-countries="['SA', 'KW', 'AE', 'QA', 'EG', 'JO', 'OM', 'YE', 'BH', 'IQ']" 
                    defaultCountry="SA" 
                    :inputOptions="inputOptions" 
                    :inputprops="{ name: 'phoneNumber', id: 'phoneNumber', required: true, placeholder: 'WhatsApp number' }" 
                    :disabled="loading" 
                  />
                </div>
              </div>
                <div class="form-pop-en email-form-pop-en">
                <label for="email" class="pop-label-en">Email Address</label>
                <input type="email" class="pop-input-en" id="email" placeholder="example@email.com" v-model="email" 
                  required :disabled="loading" />
              </div>
              <input type="hidden" v-model="fullPhoneNumber" />
              
              <!-- <div class="text-start text-[#555555]">Don’t miss out sign up now and enjoy the benefits!</div> -->
  
              <button type="submit" class="pop-btn-en" :disabled="loading">Subscribe Now</button>
            </form>
            <div v-if="loading" class="spinner-overlay">
              <div class="spinner"></div>
            </div>
            <p class="pop-bottom-en">
              We only use your details for this request. <br class="hidden-mob-en"/>
              <a href="/en/terms-and-conditions">See Terms of use</a>
            </p>
          </div>
          <div class="popup-image-en"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import { VueTelInput } from 'vue3-tel-input';
  import 'vue3-tel-input/dist/vue3-tel-input.css';

  export default {
    props: {
      show: Boolean,
    },
    emits: ['close'],
    components: {
      VueTelInput,
    },
    data() {
      return {
        // showPopup: false,
        fullName: '',
        email: '',
        phoneNumber: '',
        country: null,
        inputOptions: {
          hiddenInput: true,
        },
        isValidPhone: false,
        fullPhoneNumber: '',
        loading: false,
      };
    },
    methods: {
      onPhoneInput(formattedNumber, phoneObject) {
        if (phoneObject && phoneObject.number) {
          console.log('Phone Input:', formattedNumber, phoneObject);
          this.fullPhoneNumber = phoneObject.number;
        }
      },
      onPhoneValidate(isValid, phoneObject) {
        console.log('Validation Result:', isValid);
        this.isValidPhone = isValid;

        if (isValid && phoneObject && phoneObject.number) {
          this.fullPhoneNumber = isValid.number;
        } else if (!isValid) {
          console.warn('Phone number is not valid.');
        }
      },
      closePopup() {
        // this.showPopup = false;
        this.$emit('close');
        sessionStorage.setItem('popupShown', 'true');
      },
      register() {
        if (!this.fullPhoneNumber) {
          console.error('Phone number is missing or invalid.');
          return;
        }

        // Start loading
        this.loading = true;

        const payload = {
          name: this.fullName,
          email: this.email,
          phone: this.fullPhoneNumber,
        };

        let headers = { 'Content-Type': 'application/json' };
        axios.post(`/api/free-session-forms`, payload, { headers })
          .then(response => {
            const data = response.data;
            if (response.status === 201) {
              console.log('Form submitted successfully:', data);
              this.formSubmitted = true;
              this.closePopup();
            } else {
              console.error('Error in response:', data.message || 'Unknown error');
            }
          })
          .catch(error => {
            console.error('Error submitting form:', error);
          })
          .finally(() => {
            // Stop loading
            this.loading = false;
          });
      },
    },
  };
</script>

<style scoped>
  .popup-overlay-en {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    direction: ltr;
    font-family: 'DIN Next LT Arabic-n', sans-serif;
    overflow: auto;
  }

  .popup-content-en {
    background: white;
    display: flex;
    max-width: 990px;
    width: 100%;
    max-height: 100%;
    border-radius: 20px;
    position: relative;
  }

  .popup-body-en {
    display: flex;
    width: 100%;
  }

  .popup-text-en {
    flex: 1;
    padding: 50px;
    text-align: start;
    line-height: 1.5;
    margin-top: 10px;
  }

  .popup-heading-four-en {
    font-size:22px; 
    font-weight:400; 
    color:#555555; 
    margin-bottom:20px; 
    line-height:1.1;
  }
  
  .popup-heading-two-en {
    font-size:44px; 
    font-weight:700; 
    color:#ff6f00; 
    margin-bottom:10px; 
    line-height:1.1;
  }

  .pop-card-en {
    background: linear-gradient(45deg, #ff9442, #ff6f00);
    color: white;
    border-radius: 0 25px 25px 0;
    margin-inline-start: -30px;
    padding-inline-start: 30px;
    margin-top: 10px;
    padding-top: 8px;
    padding-bottom: 16px;
  }

  .pop-card-en p {
    line-height: 90%;
    font-size: 1.75em; /* adjusted to relative unit */
    font-weight: 500;
  }

  .pop-desc-en, .pop-desc2-en  {
    line-height: normal;
    font-size: 22px;
    font-weight: 600;
    margin-top: 20px;
    margin-bottom: 0px;
    color: #165E84;
  }

  .pop-desc2-en {
    font-size: 16px;
    font-weight: 500;
  }

  .pop-desc3-en {
    font-size: 18px;
    font-weight: 700;
    color: #165E84;
  }

  .pop-sub-desc3-en {
    font-size: 16px;
    font-weight: 700;
    color: #165E84;
    margin-bottom: 10px;
  }

  .pop-desc-en span {
    color: #ff6f00;
  }

  .pop-desc2-mob-en, .pop-desc3-mob-en {
    display: none;
  }

  .popup-image-en {
    flex: 1;
    background-image: url('https://monglish.b-cdn.net/home/popup/popup-6-levels-en.png');
    background-size: cover;
    background-position: center;
    border-radius: 0 20px 20px 0;
    padding: 0;
    width: 100%;
  }

  .popup-image-mob-en {
    display: none;
  }

  .close-button-en {
    position: absolute;
    top: 0.8rem;
    left: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding-bottom: 10px;
    border: 2px solid #165E84;
    background: transparent;
    color: #165E84;
    font-size: 2rem;
    font-weight: 400;
    cursor: pointer;
  }

  form div {
    margin-bottom: 1.25em; /* adjusted to relative unit */
  }

  .pop-form-en {
    text-align: right;
    direction: ltr;
  }

  .form-pop-en:first-child .pop-input-en {
    padding-block: 0.8em;
  }

  .pop-input-en {
    width: calc(100% - 1.25em); /* adjusted to relative unit */
    padding: 0.625em; /* adjusted to relative unit */
    margin: 0;
    margin-right: 1.7em;
    border-radius: 10px;
    background-color: #f3f7ff;
    border: none;
    text-align: left;
  }

  form .form-pop-en {
    margin-bottom: 10px; /* adjusted to relative unit */
  }

  form .email-form-pop-en {
    margin-bottom: 20px;
  }

  .email-form-pop-en .pop-input-en {
    padding-block: 0.8em;
  }

  .pop-label-en {
    display: block;
    margin-left: 0; /* adjusted to relative unit */
    text-align: left;
    font-weight: 500;
    color: #bababa;
    margin-top: 0; /* adjusted to relative unit */
     /* Consistent spacing */
     margin-bottom: 5px;
    /* Added spacing below label */
  }

  .pop-bottom {
    color: #979797;
    font-family: 'DIN Next LT Arabic-n';
    font-weight: 700;
    margin-top: 20px;
    /* Consistent margin */
  }

  .pop-bottom a {
    color: #165e84;
    text-decoration: underline;
  }

  .inline-group-en {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0;
  }

  .inline-group-en .form-group-en {
    width: 48%;
  }

  .pop-btn-en {
    background: linear-gradient(45deg, #ff9442, #ff6f00);
    color: white;
    border: none;
    padding: 0.25rem 0.25rem; /* adjusted to relative unit */
    cursor: pointer;
    border-radius: 20px;
    width: 100%;
    font-size: 1.5em; /* adjusted to relative unit */
    font-family: 'DIN Next LT Arabic', sans-serif;
  }

  .pop-bottom-en {
    color: #979797;
    font-weight: 500;
    margin-top: 20px;
  }

  .pop-bottom-en a {
    color: #165e84;
  }

  /* Small screens (max-width: 768px) */
  @media (max-width: 1000px) {
    .popup-overlay-en {
      align-items: center;
    }

    .popup-content-en {
      max-width: 90%;
      flex-direction: column;
    }

    .popup-head-en {
      display: flex;
    }

    .pop-desc-en {
      font-size: 18px;
    }

    .popup-text-en {
      padding: 1.5em;
      padding-top: 0;
    }
    .popup-heading-two-en {
      font-size: 20px;
      margin-bottom: 5px;
      text-align: center;
    }
    .popup-heading-four-en {
      font-size: 16px;
      margin-bottom: 5px;
      text-align: center;
    }

    .pop-card-en {
      margin-inline-start: -1.5em;
    }
    .pop-card-en p {
      font-size: 1.25em;
    }
    .pop-desc-en {
      margin-top: 0;
      text-align: center;
    }
    .pop-desc2-en, .pop-desc3-en, .pop-sub-desc3-en {
      display: none;
    }
    .pop-desc2-mob-en {
      display: block;
      text-align: center;
      color: #165E84;
      font-size: 22px;
      font-weight: 600;
      margin-top: 10px;
      margin-bottom: 0;
      line-height: normal;
      background: none;
      border-radius: 0;
      padding: 0;
    }

    .pop-desc3-mob-en {
      display: block;
      text-align: center;
      color: #165E84;
      font-weight: 700;
      font-size: 15px;
    }

    .popup-image-en {
      display: none;
    }
    .popup-image-mob-en {
      display: flex;
      background-image: url('https://monglish.b-cdn.net/home/popup/WhatsApp%20Image%202025-08-27%20at%2019.13.50_88c663d0.jpg');
      background-size: cover;
      background-position: center;
      border-radius: 20px;
      width: 100%;
      height: 100%;
      padding: 4rem;
    }

    .close-button-en {
      top: -50px;
      right: 10px;
      color: #fff;
      border-color: #fff;
    }
    .pop-input-en {
      width: calc(100% - 1em); /* adjust width for smaller screens */
    }
    
    form .form-pop {
      margin-bottom: 5px;
    }

    form .email-form-pop {
      margin-bottom: 10px;
    }

    .pop-btn-en {
      padding: 0.75em 1em; /* adjust padding for smaller screens */
      font-size: 1.25em; /* adjust font size for smaller screens */
      margin-inline: 0;
      width: 100%;
    }
    .inline-group-en {
      align-items: center;
    }

    .hidden-mob-en {
      display: none;
    }
  }

  .vue-tel-input {
    direction: ltr;
  }

  .vue-tel-input:focus-within {
    box-shadow: unset !important;
  }

  /* loading spinner */
  .popup-disabled {
    pointer-events: none; /* Disable interaction while loading */
  }

  .form-disabled {
    pointer-events: none; /* Disable form interaction while loading */
  }

  .spinner-overlay {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(128, 128, 128, 0.5); /* Gray background with 0.8 opacity */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000; /* Ensure spinner is above everything else */
  }

  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-right-color: #ffe100;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  /* loading spinner */
</style>